import React, { useState, useMemo, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  TextField,
  TablePagination,
  Button,
  Box,
  InputAdornment,
  Modal,
  CircularProgress,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const VendorQualificationTable = ({ vendors, isLoading, getVendorTenders, tab }) => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const {tenderId} = useParams();
  const [status, setStatus] = useState();
  const [reason, setReason] = useState();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
    const [btnLoading, setBtnLoading] = useState(false);
  
    const validateForm = () => {
      const newErrors = {};
  
      const isEmpty = (value) => !value || value.trim?.() === "";
  
      if (isEmpty(reason)) newErrors.reason = "Reason is required";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

  const handleOpen = (s) => {
    setOpen(true);
    setStatus(s);
  };
  const handleClose = () => {
    setOpen(false);
    setStatus("");
    setReason("");
  };

  const handleSelectAllClick = (event, tenderVendors) => {
    const tenderVtIds = tenderVendors.map((v) => v.vendorTender.vtId);

    if (event.target.checked) {
      // Select all: merge existing selected with new ones and remove duplicates
      const newSelected = Array.from(new Set([...selected, ...tenderVtIds]));
      setSelected(newSelected);
    } else {
      // Deselect all: remove only the tender-specific ids
      const filtered = selected.filter((id) => !tenderVtIds.includes(id));
      setSelected(filtered);
    }
  };

  const handleClick = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter((selectedId) => selectedId !== id);
    }
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const paginatedVendors = useMemo(() => {
    return (vendors || []).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [vendors, page, rowsPerPage]);

  const handleVendorTenderUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      const payload = selected.map((id) => ({
        vtId: id,
        status: status,
        username: storedUser.username,
        comment: reason,
      }));

      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender`,
        payload,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSelected([]);
      setOpen(false);
      getVendorTenders();
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  useEffect(() => {
    getVendorTenders(page);
  }, [page]);
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <Box
        display={"flex"}
        justifyContent={tab == 1 ? "space-between" : "end"}
        alignItems={"center"}
      >
        {tab === 1 &&
        <Box>
          <Button
            className="accept-all"
            onClick={() => handleOpen(storedUser.userRole[0] === "BUYER" ? "QSTAGE_1" : storedUser.userRole[0] === "TECHNICAL_HEAD" ? "QSTAGE_2" : "QUALIFIED")}
          >
            Approve Selected
          </Button>
          <Button
            className="reject-all"
            onClick={() => handleOpen("DISQUALIFIED")}
          >
            Reject Selected
          </Button>
        </Box>}
        <Box
          display="flex"
          justifyContent="end"
          alignItems="center"
          gap={1}
          p={2}
        >
          <TextField
            placeholder="Search"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              width: 300,
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
              "&:hover": {
                borderRadius: "12px",
                background: "#D8E9F0",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          {/* <Button
            startIcon={<FilterListIcon />}
            sx={{
              height: 40,
              border: "1px solid #c7c7c7 !important",
              borderRadius: "12px",
              color: "#000",
              textTransform: "none",
              backgroundColor: "none",
              ":hover": {
                backgroundColor: "none",
              },
            }}
            onClick={() => {
              // Optional: Toggle a filter modal/panel if needed
              console.log("Filter button clicked");
            }}
          >
            Filter
          </Button> */}
        </Box>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
            {tab === 1 &&
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    selected.length > 0 &&
                    selected.length <
                      Object.values(paginatedVendors || {}).flat().length
                  }
                  checked={
                    selected.length > 0 &&
                    selected.length ===
                      Object.values(paginatedVendors || {}).flat().length
                  }
                  onChange={(event) =>
                    handleSelectAllClick(
                      event,
                      Object.values(paginatedVendors || {}).flat()
                    )
                  }
                />
              </TableCell>}
              <TableCell>Name</TableCell>
              <TableCell>Mobile</TableCell>
              <TableCell>PAN</TableCell>
              <TableCell>GSTIN</TableCell>
              <TableCell>View</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : paginatedVendors.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No rows
                </TableCell>
              </TableRow>
            ) : (
              paginatedVendors.map((row, index) => {
                const isItemSelected = isSelected(row.vendorTender.vtId);
                return (
                  <TableRow
                    key={row.vtqId}
                    hover
                    role="checkbox"
                    selected={isItemSelected}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#EAF4FF" : "#ffffff",
                    }}
                  >
                    {tab === 1 &&
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onChange={() => handleClick(row.vendorTender.vtId)}
                      />
                    </TableCell>}
                    <TableCell>
                      <strong>{row.name}</strong>
                    </TableCell>
                    <TableCell>{row.mobile}</TableCell>
                    <TableCell>{row.pan}</TableCell>
                    <TableCell>{row.gstin}</TableCell>
                    <TableCell>
                      <Link to={`/dashboard/${tenderId}/vendor/${row.vtqId}`}>View</Link>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={vendors?.length || 0}  
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 1));
          setPage(0); // reset to first page when page size changes
        }}
        rowsPerPageOptions={[]}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" fontWeight={"bold"}>
            {status === "DISQUALIFIED" ? "Reject the Vendor" : "Accept the Vendor"}
          </Typography>
          <label htmlFor="reason">
            Please give reason for {status === "DISQUALIFIED" ? "Reject" : "Accept"}ing the vendor*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value)
              setErrors({reason: ""})
            }}
            rows={8}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className={
                status === "DISQUALIFIED"
                  ? "btn-outlined btn-reject"
                  : "btn-contained"
              }
              onClick={handleVendorTenderUpdate}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting..." : status === "DISQUALIFIED" ? "Reject" : "Accept"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default VendorQualificationTable;
